import React from 'react';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import { withTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import fromAnyToString from 'utils/converters/fromAnyToString';

import Checkbox from 'settings/page-elements/dropdown/Checkbox';

import CN from './ListItem.module.scss';

class ListItem extends React.Component {
  static defaultProps = { generalName: '' };

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      description: props.description,
      serviceToggleTime: 0,
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.description !== this.props.description) {
      this.setState({ description: nextProps.description });
    }
  }

  onCheckboxClick = (value) => {
    const seconds = new Date().getSeconds();
    const { serviceToggleTime } = this.state;
    if (Math.abs(serviceToggleTime - seconds) < 1) {
      return;
    }
    this.setState({ serviceToggleTime: seconds });
    const id = parseInt(this.props.id.split('x')[0], 10);
    this.props.onCheckboxClick(this.props.itemName, id, value);
  };

  expandedText = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const componentClasses = cn({
      [CN.component]: true,
      [CN.darkMode]: this.props.isDarkMode,
    });

    const stateClass = cn({
      [CN.description]: true,
      [CN.isOpen]: !this.state.expanded,
    });

    return (
      <div data-bem="ListItem" className={componentClasses}>
        <div className={CN.generalInfo}>
          <label htmlFor={this.props.id} className={CN.item}>
            <Checkbox isChecked={this.props.checked} id={this.props.id} onCheckboxClick={this.onCheckboxClick} />
          </label>
          <span className={CN.title}> {this.props.itemName}</span>
        </div>

        {this.props.generalName !== 'Business Hours' && ( // OMG
          <div className={CN.additionalInfo}>
            {this.state.description ? (
              <div className={CN.servicesText}>
                <span className={stateClass}>{this.state.description}</span>
                {/*  TODO: Maya to calc and find correct way for this functionality ...blabla.length >= 50 */}
                {fromAnyToString(this.state.description).length >= 50 ? (
                  <div
                    className={cn({
                      [CN.buttonContainer]: true,
                      [CN.isOpen]: !this.state.expanded,
                    })}
                  >
                    <Button onClick={this.expandedText} variant="slim">
                      {this.state.expanded
                        ? this.props.t('composite.listItem.viewLess')
                        : this.props.t('composite.listItem.readMore')}
                    </Button>
                  </div>
                ) : (
                  <div />
                )}
              </div>
            ) : (
              <div />
            )}
          </div>
        )}
      </div>
    );
  }
}

const ListItemHoc = withTranslation()(withTheme()(ListItem));

export default ListItemHoc;
